<template>
  <div class="loginPage" v-if="showFlag">
    <div class="loginBox">
      <div class="loginTitle">
        <img class="loginLogo" src="@/assets/loginLogo.png" alt />
      </div>
      <el-form
        class="loginForm"
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
      >
        <el-form-item prop="username">
          <el-input
            placeholder="请输入工号或手机号"
            prefix-icon="el-icon-s-custom"
            v-model="loginForm.username"
            @keyup.enter.native="$refs.pwd.focus"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            ref="pwd"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            @keyup.enter.native="loginBtn"
            show-password
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <p class="aboutPwd" style="padding-bottom: 10px; margin-top: -10px;">
        <el-checkbox v-model="rememberLoginInfo">记住登录信息</el-checkbox>
        <el-checkbox v-model="cleanToken">踢除其它登录</el-checkbox>
      </p>
      <div class="loginBtnBox">
        <el-button type="primary" @click="loginBtn">登录</el-button>
      </div>  
      <p class="aboutPwd">
        <el-link type="primary" :underline="false" @click="newUser">申请帐号<i class="iconfont icon-new"></i></el-link>
        <el-link type="primary" :underline="false" @click="forgetPwd">忘记密码？</el-link>
      </p>
      <p class="copyright">
        Copyright © 2005-2024 深圳奥尼电子股份有限公司 粤ICP备11023648号
      </p>
    </div>    
  </div>
</template>

<script>
import {apiSSOLogin, apiUserLogin} from "../../api/userApi.js";
import { setLocalStorage, setSessionStorage } from "@/utils/myStorage.js";
import { getLastModulePath } from "@/utils/lastModule.js";
export default {
  data() {
    return {
      loginForm: {},
      loginRules: {
        username: [
          { required: true, message: "账号不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空！", trigger: "blur" },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur",
          },
        ],
      },
      rememberLoginInfo: true,
      cleanToken: true,
      labelWidth: "70px",
      showFlag: false,
    };
  },
  methods: {
    // 计算登录后的默认跳转地址：优先直接访问的URL，否则最后打开的一级模块，否则默认
    defaultHomePath() {
      if (this.$store.state.directVisitUrl) {
        return this.$store.state.directVisitUrl;
      }
      const lastPath = getLastModulePath();
      if (lastPath) {
        return lastPath;
      }
      return "/homePage/productionOrder";
    },
    // 用户登录
    async loginBtn() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const res = await apiUserLogin({
            password: this.loginForm.password,
            username: this.loginForm.username,
            cleanToken: this.cleanToken,
          });
          // console.log(res);
          if (res.code == 0) {
            this.$store.state.userInfo = res.data;
            this.$message({
              message: "登录成功",
              type: "success",
            });
            if (res.data.isAllowLogin) {
              if (this.rememberLoginInfo) {
                setLocalStorage("userInfo", res.data);
              } else {
                setSessionStorage("userInfo", res.data);
              }
              this.$router.push(this.defaultHomePath());
            } else {
              this.$router.push(`/productSystem`);
              setSessionStorage("userInfo", res.data);
            }
          }
        } else {
          return false;
        }
      });
    },
    newUser() {
      this.$alert(
        <span>
          该功能已禁用，请通过OA申请流程开通帐号及权限！
        </span>,
        "申请帐号",
        {
          confirmButtonText: "确定",
        }
      );
    },
    // 忘记密码
    forgetPwd() {
      this.$alert(
        <span>
          请将您的：工号、姓名，<br/>发送邮件至{" "}
          <strong>
            <a class="el-link el-link--primary" style="margin-top: -5px;" href="mailto:aoni229@anc.cn?cc=rd78@anc.cn&subject=申请重置AIM电子智能制造密码&body=<b>申请人</b><br/>姓名：XXX<br/>工号：YYYYYYYY">
              aoni229@anc.cn
            </a>
          </strong>{" "}
          申请重置密码。
          <a class="el-link el-link--primary" style="margin-top: -5px;" href="mailto:aoni229@anc.cn?cc=rd78@anc.cn&subject=申请重置AIM电子智能制造密码&body=<b>申请人</b><br/>姓名：XXX<br/>工号：YYYYYYYY">
            【点此发送】
          </a>
        </span>,
        "忘记密码",
        {
          confirmButtonText: "确定",
        }
      );
    },
  },
  created() {

    if(this.$route.query.code) {
      apiSSOLogin({
        code: this.$route.query.code
      }).then(res => {
        if (res.code == 0) {
          this.$store.state.userInfo = res.data;
          this.$message({
            message: "登录成功",
            type: "success",
          });
          if (res.data.isAllowLogin) {
            if (this.rememberLoginInfo) {
              setLocalStorage("userInfo", res.data);
            } else {
              setSessionStorage("userInfo", res.data);
            }
            this.$router.push(this.defaultHomePath());
          } else {
            this.$router.push(`/productSystem`);
            setSessionStorage("userInfo", res.data);
          }
        }
      })
    } else {
      this.showFlag = true
      let { userInfo } = this.$store.state;
      if (userInfo.accessToken) {
        if (userInfo.isAllowLogin) {
          this.$router.push(this.defaultHomePath());
        } else {
          this.$router.push(`/productSystem`);
        }
      }
    }
  },
  async mounted() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    document.querySelector(
      ".loginPage"
    ).style.backgroundImage = `url('/wallpaper/${year}${month}${day}.jpg')`;
  },
};
</script>

<style lang="less" scoped>
.loginPage {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  .Btn:hover {
    opacity: 0.95;
  }
  .loginBox {
    width: 537px;
    padding-bottom: 10px;
    background-color: var(--bgPanel);
    text-align: center;
    opacity: 0.88;
    .loginLogo {
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .loginTitle {
      position: relative;
      font-size: 22px;
      font-weight: 500;
      letter-spacing: 2px;
      color: var(--textPrimary);
      .loginTypeBox {
        position: absolute;
        top: 10px;
        right: 20px;
        .typeName {
          color: var(--themeColor);
          font-size: 12px;
        }
        .grayName {
          color: var(--textPlaceholder);
        }
      }
    }

    .loginForm {
      margin: 0 80px;
      .el-select {
        width: 100%;
      }
    }

    .loginBtnBox {
      margin: 0 80px 20px;
      .el-button {
        width: 100%;
      }
    }
    .aboutPwd {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // “申请帐号/忘记密码”链接跟随主题色（提高优先级，覆盖 Element 编译后的固定主色）
      .el-link--primary {
        color: var(--themeColor);

        &:hover {
          color: var(--themeColorHover);
        }
      }
    }
    .copyright {
      margin-top: 28px;
      font-size: 14px;
      color: var(--textSecondary);
    }
  }
}
</style>